"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _hamburgerReact = require("hamburger-react");

var _BurgerButton = require("./BurgerButton.style");
/* eslint-disable jsx-a11y/label-has-associated-control */


var BurgerButton = function BurgerButton(_ref) {
  var size = _ref.size,
      duration = _ref.duration,
      distance = _ref.distance,
      easing = _ref.easing,
      label = _ref.label,
      rounded = _ref.rounded,
      toggled = _ref.toggled,
      toggle = _ref.toggle,
      text = _ref.text,
      onClick = _ref.onClick,
      variation = _ref.variation;
  return /*#__PURE__*/_react.default.createElement(_BurgerButton.BurgerContainer, {
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement(_hamburgerReact.Turn, {
    size: size,
    duration: duration,
    distance: distance,
    easing: easing,
    label: label,
    rounded: rounded,
    toggled: toggled,
    toggle: toggle
  }), /*#__PURE__*/_react.default.createElement(_BurgerButton.BurgerLabel, {
    variation: variation
  }, text));
};

BurgerButton.propTypes = {
  size: _propTypes.default.string,
  duration: _propTypes.default.string,
  distance: _propTypes.default.string,
  easing: _propTypes.default.string,
  label: _propTypes.default.string,
  rounded: _propTypes.default.bool,
  toggled: _propTypes.default.bool.isRequired,
  toggle: _propTypes.default.func.isRequired,
  text: _propTypes.default.string,
  onClick: _propTypes.default.func.isRequired,
  variation: _propTypes.default.oneOf(['mega', 'primary'])
};
BurgerButton.defaultProps = {
  size: '27',
  duration: '0',
  distance: 'lg',
  easing: 'ease',
  label: 'Menu button',
  rounded: true,
  text: 'Menu',
  variation: 'primary'
};
var _default = BurgerButton;
exports.default = _default;